/**
 * Shared form-validation helpers for the Fm form system. Kept in a
 * non-component module so both the sealed FmForm and the internal legacy
 * Form.Item escape can consume it without tripping fast-refresh export rules.
 */

/** Fill the localized required-validation template with a field label. */
export const formatRequiredMessage = (template: string, label: string): string =>
  template.replace('{{label}}', label);
